export const PIPELINE = [
  "Pending Submission",
  "1st Step",
  "1st Step Pending",
  "2nd Step",
  "2nd Step Pending",
];
export const FWD_STATUSES = ["FWD", "Med/Arb", "System Board"];
export const TERM_STATUSES = ["FWD", "Arbitration"];
export const OUTCOMES = ["Settled", "Withdrawn", "Withdrawn/Resigned"];
export const STATUSES = [...new Set([...PIPELINE, ...FWD_STATUSES, ...TERM_STATUSES, ...OUTCOMES])];

export const STATUS_STYLES = {
  "Pending Submission": { bg: "#F4F4F5", text: "#52525B", border: "#E4E4E7", dot: "#A1A1AA" },
  "1st Step": { bg: "#E0F2FE", text: "#0369A1", border: "#BAE6FD", dot: "#0EA5E9" },
  "1st Step Pending": { bg: "#FEF3C7", text: "#B45309", border: "#FDE68A", dot: "#F59E0B" },
  "2nd Step": { bg: "#DBEAFE", text: "#1D4ED8", border: "#BFDBFE", dot: "#3B82F6" },
  "2nd Step Pending": { bg: "#FFEDD5", text: "#C2410C", border: "#FED7AA", dot: "#F97316" },
  "FWD to Office": { bg: "#F3E8FF", text: "#6B21A8", border: "#E9D5FF", dot: "#A855F7" },
  "Termination": { bg: "#FEE2E2", text: "#B91C1C", border: "#FECACA", dot: "#EF4444" },
  "FWD": { bg: "#F3E8FF", text: "#6B21A8", border: "#E9D5FF", dot: "#A855F7" },
  "Med/Arb": { bg: "#FCE7F3", text: "#9D174D", border: "#FBCFE8", dot: "#EC4899" },
  "System Board": { bg: "#E0E7FF", text: "#3730A3", border: "#C7D2FE", dot: "#6366F1" },
  "Arbitration": { bg: "#FEF9C3", text: "#854D0E", border: "#FEF08A", dot: "#EAB308" },
  "Settled": { bg: "#DCFCE7", text: "#15803D", border: "#BBF7D0", dot: "#22C55E" },
  "Withdrawn": { bg: "#E5E7EB", text: "#374151", border: "#D1D5DB", dot: "#6B7280" },
  "Withdrawn/Resigned": { bg: "#E5E7EB", text: "#374151", border: "#D1D5DB", dot: "#6B7280" },
};

export const CHART_COLORS = ["#18181B", "#0EA5E9", "#F59E0B", "#3B82F6", "#F97316", "#A855F7", "#22C55E", "#6B7280"];
